import { connect } from 'react-redux';

import { IObjectsDisclaimerProps, ObjectsDisclaimer } from '../../components/ObjectsDisclaimer';
import { IState } from '../../store';

export type TStoreProps = Pick<IObjectsDisclaimerProps, 'isVisible' | 'mediaType'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    isVisible: !!state.villageData.village.isStale,
    mediaType: state.device.deviceType === 'desktop' ? 'desktop' : 'mobile',
  };
}

export const ObjectsDisclaimerContainer = connect<TStoreProps>(mapStateToProps)(ObjectsDisclaimer);
